<template>
    <v-card-text>
        <v-container>
            <v-row>
                <v-col
                    cols="12"
                    sm="6"
                    md="6"
                >
                    <v-text-field
                        v-model="$store.state.smaStorageEditedItem.REFERENCE"
                        label="REFERENCE (*)"
                        :rules="[() => !!$store.state.smaStorageEditedItem.REFERENCE]"
                        :error-messages="$store.state.errorMessages"
                        required
                   ></v-text-field>
                </v-col>
                <v-col
                    cols="12"
                    sm="12"
                    md="12"
                >
                    <v-text-field
                        v-model="$store.state.smaStorageEditedItem.SYSTEM_ID"
                        label="SYSTEM_ID (*)"
                        :rules="[() => !!$store.state.smaStorageEditedItem.SYSTEM_ID]"
                        :error-messages="$store.state.errorMessages"
                        required
                    ></v-text-field>
                </v-col>
                <v-col
                    cols="12"
                    sm="12"
                    md="12"
                >
                    <v-text-field
                        v-model="$store.state.smaStorageEditedItem.DESC_NL"
                        label="DESC_NL (*)"
                        :error-messages="$store.state.errorMessages"
                    ></v-text-field>
                </v-col>
                <v-col
                    cols="12"
                    sm="12"
                    md="12"
                >
                    <v-text-field
                        v-model="$store.state.smaStorageEditedItem.DESC_FR"
                        label="DESC_FR (*)"
                        :error-messages="$store.state.errorMessages"
                    ></v-text-field>
                </v-col>
                <v-col
                    cols="6"
                    sm="4"
                    md="4"
                >
                    <v-text-field
                        v-model="$store.state.smaStorageEditedItem.TYPE"
                        label="TYPE (*)"
                        :rules="[() => !!$store.state.smaStorageEditedItem.TYPE]"
                        :error-messages="$store.state.errorMessages"
                        required
                    ></v-text-field>
                </v-col>
                <v-col
                    cols="6"
                    sm="2"
                    md="2"
                >
                    <v-text-field
                        v-model="$store.state.smaStorageEditedItem.QUANTITY"
                        label="QUANTITY (*)"
                        :error-messages="$store.state.errorMessages"
                    ></v-text-field>
                </v-col>
                <v-col
                    cols="6"
                    sm="6"
                    md="6"
                >
                    <v-text-field
                        v-model.number="$store.state.smaStorageEditedItem.DC_CURRENT"
                        label="DC_CURRENT (*)"
                        :rules="[numberInputsMin1Rule]"
                        :error-messages="$store.state.errorMessages"
                        type="number"
                    ></v-text-field>
                </v-col>
                <v-col
                    cols="6"
                    sm="4"
                    md="4"
                >
                    <v-text-field
                        v-model="$store.state.smaStorageEditedItem.DC_CABLE"
                        label="DC_CABLE (*)"
                        :error-messages="$store.state.errorMessages"
                    ></v-text-field>
                </v-col>
                <v-col
                    cols="6"
                    sm="4"
                    md="4"
                >
                    <v-text-field
                        v-model="$store.state.smaStorageEditedItem.FAMILY"
                        label="FAMILY (*)"
                        :error-messages="$store.state.errorMessages"
                    ></v-text-field>
                </v-col>
                <v-col
                    cols="6"
                    sm="4"
                    md="4"
                >
                    <v-text-field
                        v-model="$store.state.smaStorageEditedItem.ACCESSORIES_PB"
                        label="ACCESSORIES_PB (*)"
                        :error-messages="$store.state.errorMessages"
                    ></v-text-field>
                </v-col>
            </v-row>
        </v-container>
    </v-card-text>
</template>

<script>
	export default {
		name: "FormulaireSmaStorage",
		data: function () {
			return {
            }
        }
    }
</script>
